import IMask from 'imask';

export const apply = (el, options) => {
  IMask(el, options);
};

export const repeated = (el, options, charMask, min, max) => {
  const totalOptionalsChars = max - min;

  let mask = '';

  for (let i = 0; i < min; i++) {
    mask += charMask;
  }

  for (let i = 0; i < totalOptionalsChars; i++) {
    mask += `[${charMask}]`;
  }

  options.mask = mask;

  apply(el, options);
};
